import React, { useState, useEffect } from 'react';

export function UseScreenOrientation() {
  const [isLandscape, setIsLandscape] = useState<boolean>();
  useEffect(() => {
    function handleOrientation(screenType: string) {
      setIsLandscape(screenType == 'landscape' ? true : false);
    }
    function handleResize() {
      if (window.innerWidth < 998) {
        handleOrientation('portrait');
      } else {
        handleOrientation('landscape');
      }
    }
    window.addEventListener('resize', handleResize);

    if (screen && screen.orientation) {
      screen.orientation.onchange = function () {
        if (screen.orientation.type) {
          const matches = screen.orientation.type.match(/\w+/);
          if (matches && matches.length) {
            const orientation = matches[0];
            handleOrientation(orientation);
          }
        }
      };
    }
    if (window.innerWidth < 998) {
      handleOrientation('portrait');
    } else {
      handleOrientation('landscape');
    }
  }, []);
  return isLandscape;
}
